import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import logo from "../../asset/images/logo.png";

const ProgressBar = ({ progress, prof }) => {
  const totalSteps = prof ? 10 : 6;
  const currentStep = Math.max(
    1,
    Math.min(totalSteps, progress === 12 ? totalSteps : Number(progress) || 1)
  );
  const percent = Math.round((currentStep / totalSteps) * 100);

  return (
    <Box
      dir="rtl"
      sx={{
        width: "100%",
        maxWidth: 620,
        mx: "auto",
        mt: { xs: 1.5, sm: 2.25 },
        px: { xs: 1.25, sm: 2 },
        boxSizing: "border-box",
        fontFamily: "Assistant, sans-serif",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "62px 1fr", sm: "76px 1fr" },
          alignItems: "center",
          gap: { xs: 1.4, sm: 2 },
          p: { xs: 1.25, sm: 1.6 },
          borderRadius: { xs: "18px", sm: "22px" },
          background: "linear-gradient(135deg, #FFFFFF 0%, #F1F8FE 100%)",
          border: "1px solid rgba(24, 132, 207, .18)",
          boxShadow: "0 10px 28px rgba(18, 83, 132, .11)",
        }}
      >
        <Box
          sx={{
            width: { xs: 62, sm: 76 },
            height: { xs: 62, sm: 76 },
            display: "grid",
            placeItems: "center",
            borderRadius: "50%",
            bgcolor: "#FFFFFF",
            border: "3px solid #2298DD",
            boxShadow: "0 7px 20px rgba(27, 117, 181, .2)",
            boxSizing: "border-box",
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Bidit"
            sx={{
              width: { xs: 50, sm: 62 },
              height: { xs: 50, sm: 62 },
              display: "block",
              objectFit: "contain",
              borderRadius: "50%",
              p: "0 !important",
              m: "0 !important",
              boxSizing: "border-box",
            }}
          />
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 0.9 }}>
            <Box>
              <Typography sx={{ fontFamily: "Assistant", color: "#153B5B", fontWeight: 900, fontSize: { xs: ".98rem", sm: "1.08rem" }, lineHeight: 1.25 }}>
                מתקדמים בהרשמה
              </Typography>
              <Typography sx={{ fontFamily: "Assistant", color: "#647C8E", fontWeight: 650, fontSize: { xs: ".78rem", sm: ".86rem" }, mt: 0.2 }}>
                {prof ? "חשבון בעל מקצוע" : "חשבון לקוח"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "0 0 auto",
                px: 1.1,
                py: 0.5,
                borderRadius: "999px",
                bgcolor: "#E4F3FD",
                color: "#0877C9",
                fontFamily: "Assistant",
                fontSize: { xs: ".76rem", sm: ".84rem" },
                fontWeight: 900,
              }}
            >
              שלב {currentStep} מתוך {totalSteps}
            </Box>
          </Box>

          <LinearProgress
            variant="determinate"
            value={percent}
            aria-label={`התקדמות בהרשמה: ${percent}%`}
            sx={{
              height: 10,
              borderRadius: "999px",
              bgcolor: "#DDEBF5",
              direction: "rtl",
              "& .MuiLinearProgress-bar": {
                borderRadius: "999px",
                background: "linear-gradient(90deg, #1680C8 0%, #28A8E8 100%)",
                transition: "transform 260ms ease",
              },
            }}
          />
          <Typography sx={{ mt: 0.55, fontFamily: "Assistant", color: "#718697", fontSize: ".75rem", fontWeight: 700 }}>
            {percent}% הושלמו
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProgressBar;
